import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Button, Icon } from 'rsuite';
import styled from 'styled-components';
import htmlParser from 'react-html-parser';
import { fullAccess, modifyAccess } from '../../../../helpers/permission';
import formatFullName from '../../../../helpers/formatFullName';
import * as PERMISSIONS from '../../../../constants/permissions';
import { NoteType } from '../../../../interfaces';
import AccessControl from '../../../AccessControl';

const Paragraph = styled.p`
  font-size: 15px;
  margin-bottom: 10px;
`;

const Content = styled.div`
  font-size: 15px;
`;

const NoteItem = ({ data, onEdit, onDelete, ...props }) => {
  const { createdAt, member, note, id } = data;
  const [deleteBtnColor, setDeleteBtnColor] = useState({});

  const handleOnEdit = () => {
    onEdit(data);
  };

  const handleOnDelete = () => {
    onDelete(id);
  };

  const handleDeleteMouseover = color => () => {
    if (color) setDeleteBtnColor({ color });
    else setDeleteBtnColor({});
  };

  return (
    <div {...props}>
      <div style={{ float: 'right', marginTop: -5 }}>
        <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.MANAGE_NOTE)}>
          <Button
            size="sm"
            style={{ marginRight: 10 }}
            onClick={handleOnEdit}
            appearance="primary"
          >
            <Icon icon="eye" /> Edit
          </Button>
        </AccessControl>
        <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.MANAGE_NOTE)}>
          <Button
            size="sm"
            onClick={handleOnDelete}
            onMouseOver={handleDeleteMouseover('red')}
            onFocus={handleDeleteMouseover('red')}
            onMouseOut={handleDeleteMouseover('')}
            onBlur={handleDeleteMouseover('')}
            {...deleteBtnColor}
          >
            <Icon icon="trash" /> Delete
          </Button>
        </AccessControl>
      </div>
      <Paragraph>
        {moment(createdAt).format('lll')} &nbsp;[
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`/manage/team/view/${member.id}`}
        >
          {formatFullName([member.firstname, member.lastname])}
        </a>
        ]
      </Paragraph>
      <Content>{htmlParser(note)}</Content>
    </div>
  );
};

NoteItem.propTypes = {
  data: NoteType.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default NoteItem;
